var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class AtenVideoSwitcher {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.apiState = 'username';
        this.firmwareVersion = '3.2.313';
        this.maxNumberOfOutputs = 16;
        this.numberOfVideoOutputs = 4;
        this.timeouts = new Timeouts();
        this.videoMatrixRoutes = Array(this.maxNumberOfOutputs).fill(1);
        this.apiAsyncHandlers = [
            {
                name: 'echo',
                regExp: /echo on/i,
                callback: (match) => {
                    this.socket.send(`Command OK`);
                },
            },
            {
                name: 'readQuery',
                regExp: /read/i,
                callback: (match) => {
                    this.socket.send(`read Command OK`);
                    for (let i = 0; i < this.numberOfVideoOutputs; i++) {
                        const output = (i + 1).toString().padStart(2, '0');
                        const input = this.videoMatrixRoutes[i].toString().padStart(2, '0');
                        this.socket.send(`o${output} i${input} video on`);
                    }
                    this.socket.send('----- Device Information -----');
                    this.socket.send(`FW: V${this.firmwareVersion}, Build code Time stamp: Jan 08 2019 - 16:13:32`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /sw i(\d+) o(\d+)/i,
                callback: (match) => {
                    const input = parseInt(match[1], 10);
                    const output = parseInt(match[2], 10);
                    this.videoMatrixRoutes[output - 1] = input;
                    this.socket.send(`o${match[2]} i${match[1]} video on`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`Password Successful`);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
    }
    onConfigure(config) {
        var _a;
        let maxOutputNum = 4;
        for (const videoOutputConfig of Object.values((_a = config.videoOutputs) !== null && _a !== void 0 ? _a : {})) {
            const outputNum = parseInt(videoOutputConfig.code, 10);
            if (outputNum > maxOutputNum)
                maxOutputNum = outputNum;
        }
        if (maxOutputNum > this.maxNumberOfOutputs) {
            this.log.error(`video output codes exceed maximum expected value of ${this.maxNumberOfOutputs}`);
            maxOutputNum = this.maxNumberOfOutputs;
        }
        this.numberOfVideoOutputs = maxOutputNum;
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Enter Username: `);
        });
    }
}
AtenVideoSwitcher.emulatorType = 'socketEmulator';
AtenVideoSwitcher.key = '-Ls3RLKzLVRgdQm53wo7';
